import { authFetch } from "~/services/fetch";

// ! GRÁFICO DE PIZZA
export async function getOccurrencesAssociatedDrugByType({
  startDate,
  finishDate,
  drugTypeId,
  circumstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-drug-by-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        drug_type_id: drugTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedDrugByCircumstance({
  startDate,
  finishDate,
  drugTypeId,
  circumstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-drug-by-circunstance',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        drug_type_id: drugTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedDrugByDestination({
  startDate,
  finishDate,
  drugTypeId,
  circumstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-drug-by-destination',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        drug_type_id: drugTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedDrugByOccurrenceType({
  startDate,
  finishDate,
  drugTypeId,
  circumstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-drug-by-occurrence-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        drug_type_id: drugTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}